module.exports = __webpack_public_path__ + "static/media/8.5ae7bd97.mp3";